import React from "react"
import { useController } from "react-hook-form"
import { FormGroup, FormText, Label } from "reactstrap"
import PropTypes from "prop-types"
import AsyncSelect from "react-select/async"
import { t } from "i18next"

function SelectRHF(props) {
  const {
    control,
    name,
    label,
    options = [],
    defaultOptions = [],
    classNames = {},
    isClearable = true,
    ...otherProps
  } = props

  const {
    field: { value, onChange, ...field },
    fieldState,
  } = useController({ control, name })

  const select_options = options.length > 0 ? options : defaultOptions

  const loadOptions = (inputValue, callback) => {
    const result = select_options.filter(option =>
      option.label.toLowerCase().includes(inputValue.toLowerCase())
    )
    callback(result)
  }
console.log(select_options   );
  return (
    <FormGroup className={classNames.group}>
      {label ? (
        <Label className={classNames.label} htmlFor={name}>
          {label}
        </Label>
      ) : null}

      <AsyncSelect
        id={name}
        name={name}
        defaultOptions={select_options}
        loadOptions={loadOptions}
        value={
          value ? select_options.find(option => option.value === value) : value
        }
        onChange={option => onChange(option?.value ? option.value : "")}
        classNamePrefix="select"
        className={fieldState.invalid ? "invalid" : ""}
        noOptionsMessage={() => t("no options")}
        loadingMessage={() => t("loading")}
        isClearable={isClearable}
        {...field}
        {...otherProps}
      />
      {fieldState.error ? (
        <FormText color="danger" className={classNames.feedback}>
          {fieldState.error.message}
        </FormText>
      ) : null}
    </FormGroup>
  )
}
SelectRHF.propTypes = {
  name: PropTypes.string.isRequired,
  control: PropTypes.object.isRequired,
  options: PropTypes.array.isRequired,
  defaultOptions: PropTypes.array,
  isLoading: PropTypes.bool,
  onMenuOpen: PropTypes.func,
  label: PropTypes.string,
  isClearable: PropTypes.bool,
  classNames: PropTypes.shape({
    group: PropTypes.string,
    select: PropTypes.string,
    input: PropTypes.string,
    feedback: PropTypes.string,
  }),
}

export default SelectRHF
